import { h } from 'preact';

export function IconPlayerPlay({ width = 22, height = 22, fill = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={fill}
      width={width}
      height={height}
      class="icon-player-play"
    >
      <path d="M8 5v14l11-7z" />
    </svg>
  );
}
